import Loadable from 'react-loadable';

import { SpinnerWrapper } from '@containers/Navigation';
import { Path } from '@const/consts';
import { IRoute } from '@common/Routing/components/RouteWithSubRoutes/types';
import SigninForm from './components/Signin/SigninForm';
import { ForgotForm } from './components/Forgot/ForgotForm';

const Register = Loadable({
  loader: () => import('@views/auth/components/Register'),
  loading: SpinnerWrapper,
});

const SSO = Loadable({
  loader: () => import('@views/auth/components/SSO'),
  loading: SpinnerWrapper,
});

export const loginRoutes: IRoute[] = [
  {
    component: SigninForm,
    exact: true,
    name: 'Signin',
    path: Path.SIGN_IN,
  },
  {
    component: ForgotForm,
    exact: true,
    name: 'Forgot',
    path: Path.FORGOT,
  },
];

export const authRoutes: IRoute[] = [
  {
    component: Register,
    exact: true,
    name: 'Register',
    path: Path.SIGN_UP,
  },
  {
    component: SSO,
    exact: true,
    name: 'SSO',
    path: Path.SSO_AUTH,
  },
];
